import React from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import { Button } from "../../../../components/Wrappers/Wrappers";

export default function AddContractorDialog(props) {
  let {
    classes,
    formData,
    contractorCreateModal,
    handleClose,
    handleChangeInput,
    handleSubmit,
  } = props;
  // console.log("MODAL__getLandlordListItems  ", getLandlordListItems);

  return (
    <Dialog fullScreen open={contractorCreateModal} onClose={handleClose}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleClose}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography variant="h6" className={classes.title}>
            Add New Contractor
          </Typography>
          <Button color="inherit" onClick={handleClose}>
            Cancel
          </Button>
        </Toolbar>
      </AppBar>
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <Typography component="h1" variant="h5">
            Add Contractor
          </Typography>

          <ValidatorForm onSubmit={handleSubmit}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Company Name*"
                  fullWidth
                  onChange={handleChangeInput}
                  name="company_name"
                  id="company_name"
                  value={formData.company_name}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              {/* <Grid item xs={12} sm={12}>
                <select
                  onChange={handleChangeInput} name="landlord"
                >
                  <option selected>Open this select menu</option>
                  {
                    getLandlordListItems && getLandlordListItems.length > 0 ?
                      getLandlordListItems.map((element, index) => (

                        <option value={element && element.id ? element.id : "NA"}>{element && element.email ? element.email : "NA"}</option>

                      ))
                      : null
                  }

                </select>

              </Grid> */}






              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Contact Name*"
                  id="contact_name"
                  fullWidth
                  onChange={handleChangeInput}
                  name="contact_name"
                  value={formData.contact_name}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>

              {/* <Grid item xs={12} sm={12}>
                <FormControl style={{ width: "100%" }}>
                  <SelectValidator
                    name="landlord"
                    value={formData.landlord}
                    fullWidth
                    label="Landlord"
                    onChange={handleChangeInput}
                  >
                    <MenuItem value="" disabled>
                    </MenuItem>
                    {
                      getLandlordListItems && getLandlordListItems.length > 0 ?
                        getLandlordListItems.map((element, index) => (

                          <option value={element && element.id ? element.id : "NA"}>{element && element.company_name ? element.company_name : "NA"}</option>

                        ))
                        : null
                    }
                  </SelectValidator>
                </FormControl>
              </Grid> */}

              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Email*"
                  id="email"
                  fullWidth
                  onChange={handleChangeInput}
                  name="email"
                  value={formData.email}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextValidator
                  label="Password*"
                  id="password"
                  fullWidth
                  onChange={handleChangeInput}
                  name="password"
                  type="password"
                  value={formData.password}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>

              <Grid item xs={12} sm={6}>
                <TextValidator
                  label="Contact No.*"
                  id="contact"
                  fullWidth
                  onChange={handleChangeInput}
                  name="contact"
                  value={formData.contact}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextValidator
                  label="Address*"
                  id="address"
                  fullWidth
                  onChange={handleChangeInput}
                  name="address"
                  value={formData.address}
                  validators={["required"]}
                  errorMessages={["this field is required"]}
                />
              </Grid>

              <Grid item xs={12}></Grid>
            </Grid>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              className={classes.submit}
            >
              Save
            </Button>
          </ValidatorForm>
        </div>
      </Container>
    </Dialog>
  );
}
